module.exports = __webpack_public_path__ + "img/history1.688d8deb.jpg";